import React, { ReactElement } from 'react';
import {
  Component,
  PuzzleButton
} from "puzzle";

type PRE_EXPAND_JOB = {
  targetLanguage: string;
  batchName: string;
};

type WORD_COUNT_SUBMISSION =  {
  isSupplierView?: boolean
  partiallyAnalyzed?: boolean
  status?: { name: string }
  submissionId?: any
  submissionName?: string
  taskId?: string
  wordCount?: number
}

type PROPS = {
  afterAction?: Function
  beforeAction?: Function
  groupBy?: 'batches' | 'languages'
  data: WORD_COUNT_SUBMISSION
  onlyNumber?: boolean
  preExpandJob?: PRE_EXPAND_JOB
  selectSubmission?: boolean
};

class WordCountLink extends Component<PROPS, any> {
  /**
   * Open word count
   */
  openWordCount = () => {
    const { data, preExpandJob, selectSubmission, beforeAction, afterAction, groupBy = 'languages' } = this.props;
    beforeAction && beforeAction();
    if ((data.wordCount !== null) || data.partiallyAnalyzed) {
      if (data.isSupplierView) {
        const { submissionName, submissionId, taskId } = data
        this.dispatch('openSupplierWordCount', '', {
          wordCountParams: {
            taskId: taskId
          },
          submissionData: data,
          submissionName,
          submissionId
        })
      } else {
        if (selectSubmission) {

          this.dispatch('openWordCount', '', {
            downloadWordCountParams: {
              downloadTmStatistics: true
            },
            groupBy,
            submission: data,
            preExpandJob
          });
        } else {

          this.dispatch('openWordCountFromDrawer', '', {
            downloadWordCountParams: {
              downloadTmStatistics: true
            },
            groupBy,
            preExpandJob
          });
        }
      }

    }
    afterAction && afterAction();
  };

  /**
   * Render "N/A" if it's unparsable file, or number + (optionally) words with support for plural
   */
  renderWordCountLink = (): ReactElement => {
    let element: ReactElement = (<span className={'pd-non-parsable-word-count'}>
                                  {this.translate('nonParsableWordCount')}
                                </span>);
    const { data, onlyNumber = null } = this.props;
    const { wordCount = 0, status, partiallyAnalyzed, isSupplierView } = data;
    // using isSupplierView because partially analyzed is always undefined in supplierView
    if ((partiallyAnalyzed || isSupplierView) && wordCount !== null) {
      if (onlyNumber) {
        if (status?.name === 'CANCELLED') {
          element = <span className={'tp-space-left-1'}>
            {wordCount}
          </span>
        } else {
          element = <PuzzleButton
            aria-label={this.translate('SRL-openWordCount') + ' ' + this.translate('wordCount', { wordCount })}
            fillMode={"link"}
            themeColor={'primary'}
            className={'tp-grid-button tp-link tp-text-underline'}
            size={'small'}
            onClick={this.openWordCount}>
            {wordCount.toString()}
          </PuzzleButton>
        }
      } else {
        element = <PuzzleButton
          aria-label={this.translate('SRL-openWordCount') + ' ' + this.translate('wordCount', { wordCount })}
          fillMode={"link"}
          themeColor={'primary'}
          className={'tp-grid-button tp-link tp-text-underline'}
          size={'small'}
          onClick={this.openWordCount}>
          {this.translate('wordCount', { wordCount })}
        </PuzzleButton>
      }
    }

    return element;
  };

  render() {

    return (
      <>
        {this.renderWordCountLink()}
      </>
    );
  }
}

export default WordCountLink;
